// Swatch dropdown 
function initializeSwatchEvents() {
  $('.color-swatch-box').click(function() {
      const nextElement = $(this).next('.grid-product__swatches');
      
      if ($('.size-swatch.active').length) {
          $('.size-swatch.active').slideUp().removeClass('active');
      }

        $('.grid-product__swatches.active').not(nextElement).slideUp().removeClass('active');
        
        nextElement.slideToggle({
            start: function() {
                $(this).css('display', 'block');
                if ($(window).width() < 767) {
                    $('html').addClass('js-drawer-open-pdp');
                }
            },
            complete: function() {
                $(this).toggleClass('active');
                if (!$(this).hasClass('active') && $(window).width() < 767) {
                    $('html').removeClass('js-drawer-open-pdp');
                }
            }
        });
    });

    $('.grid-product__swatch').click(function() {
        const parentElement = $(this).closest('.grid-product__swatches');
        
        if (parentElement.hasClass('active')) {
            parentElement.slideUp({
                complete: function() {
                    $(this).removeClass('active');
                    if ($(window).width() < 767) {
                        $('html').removeClass('js-drawer-open-pdp');
                    }
                }
            });
        }
    });
}

function initializeVariantEvents() {
  $('.variant__label').click(function() {
      const nextElement = $(this).next('.size-swatch');
      
      if ($('.grid-product__swatches.active').length) {
          $('.grid-product__swatches.active').slideUp().removeClass('active');
      }

        $('.size-swatch.active').not(nextElement).slideUp().removeClass('active');
        
        nextElement.slideToggle({
            start: function() {
                $(this).css('display', 'block');
                if ($(window).width() < 767) {
                    $('html').addClass('js-drawer-open-pdp');
                }
            },
            complete: function() {
                $(this).toggleClass('active');
                if (!$(this).hasClass('active') && $(window).width() < 767) {
                    $('html').removeClass('js-drawer-open-pdp');
                }
            }
        });
    });

    $('.size-swatch').click(function(event) {
        const clickedElement = $(event.target);
        
        if (clickedElement.is('label, input')) {
            $(this).slideUp({
                complete: function() {
                    $(this).removeClass('active');
                    if ($(window).width() < 767) {
                        $('html').removeClass('js-drawer-open-pdp');
                    }
                }
            });
        }
    });
}

function initializeCloseButtonEvent() {
    $('.mobile-box-close,.main-content').click(function() {
        $('.grid-product__swatches.active, .size-swatch.active').slideUp({
            complete: function() {
                $(this).removeClass('active');
                if ($(window).width() < 767) {
                    $('html').removeClass('js-drawer-open-pdp');
                }
            }
        });
    });
}
function initializeSlickSlider(selector, prevBtnSelector, nextBtnSelector) {
  var $slider = $(selector);
  var parentElement = $slider.closest('.dilutions-section-left');
  var itemCount = $slider.children().length;
  var isMobile = window.innerWidth <= 767;

  // Condition to initialize slider
  if (isMobile || (!isMobile && itemCount > 3)) {
      $slider.slick({
          accessibility: false,
          centerMode: !isMobile, // Center mode only on desktop
          infinite: itemCount >= (isMobile ? 2 : 4), // Infinite only if enough items
          slidesToShow: isMobile ? 1 : Math.min(3, itemCount),
          slidesToScroll: 1,
          speed: 300,
          initialSlide: isMobile ? 0 : 1, // Different initial slide for mobile/desktop
          dots: isMobile, // Dots only on mobile
          centerPadding: isMobile ? '55px' : '0px',
          rtl: false,
          appendDots: $('.slick-slider-dots'),
          arrows: !isMobile, // Arrows only on desktop
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: Math.min(3, itemCount),
                      slidesToScroll: 1,
                      centerMode: true,
                      infinite: itemCount >= 4
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      centerPadding: '55px',
                      dots: true,
                      arrows: false,
                      infinite: itemCount > 1
                  }
              }
          ]
      });

      // Play/Pause functionality
      $('.slick-play-pause').click(function() {
          if ($(this).hasClass('play')) {
              $slider.slick('slickPause');
              $(this).removeClass('play').addClass('pause');
              $(this).find('.play-button').show();
              $(this).find('.pause-button').hide();
          } else {
              $slider.slick('slickPlay');
              $(this).removeClass('pause').addClass('play');
              $(this).find('.play-button').hide();
              $(this).find('.pause-button').show();
          }
      });

      // Custom navigation buttons
      $(prevBtnSelector).click(function() {
          $slider.slick("slickPrev");
      });

      $(nextBtnSelector).click(function() {
          $slider.slick("slickNext");
      });

      // Disable prev button initially
      if ($slider.slick('slickCurrentSlide') === 0) {
          $(prevBtnSelector).addClass("slick-disabled");
      }

      // Update nav button state on change
      $slider.on("afterChange", function() {
          var currentSlide = $slider.slick('slickCurrentSlide');
          var slickObj = $slider.slick('getSlick');
          var slideCount = slickObj.slideCount;
          var slidesToShow = slickObj.options.slidesToShow;

          $(prevBtnSelector).toggleClass("slick-disabled", currentSlide === 0);
          $(nextBtnSelector).toggleClass("slick-disabled", currentSlide >= slideCount - slidesToShow);
      });
  } else {
      parentElement.addClass('no-slider');
  }
}

function initializeSlickSlidereview(selector) {
  var parentElement = $(selector).closest('.block-best-review-section');
    if ($(selector).children().length >= 4) {
        $(selector).slick({
          accessibility:false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 300,
            initialSlide: 1,
            dots: false,
            centerPadding: '0px',
            rtl: false,
        }); 
    }
    else{
      parentElement.addClass('no-slider');
    }
}  

if (window.innerWidth >= 767) {
  initializeSlickSlidereview('.block-best-review-section-inner');
}

function initializeIngredientsSlider(selector, prevBtnSelector, nextBtnSelector) {
    $(selector).slick({
      accessibility:false,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 1000,
				speed: 300,
        slidesToShow: 4,
        draggable: true,
        slidesToScroll: 4,
        variableWidth: false,
        appendDots: $('.slick-slider-dots-in'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    variableWidth: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    variableWidth: true,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '55px',
                    centerMode: true,
                    dots: true,
                    variableWidth: true
                }
            }
        ]
    });
     // Handle custom navigation buttons
     $(prevBtnSelector).click(function () {
        $(selector).slick("slickPrev");
    });

  $(nextBtnSelector).click(function () {
      $(selector).slick("slickNext");
  });

  // Initially disable the previous button
  $(prevBtnSelector).addClass("slick-disabled");

  // Update button states after each slide change
  $(selector).on("afterChange", function () {
      if ($(".slick-prev").hasClass("slick-disabled")) {
          $(prevBtnSelector).addClass("slick-disabled");
      } else {
          $(prevBtnSelector).removeClass("slick-disabled");
      }
      if ($(".slick-next").hasClass("slick-disabled")) {
          $(nextBtnSelector).addClass("slick-disabled");
      } else {
          $(nextBtnSelector).removeClass("slick-disabled");
      }
  });
  $('.overlay-btn-open').click(function() {
      $(this).closest('.ingredients-section-column').addClass('overlay-active');
  });

  $('.overlay-btn-close').click(function() {
      $(this).closest('.ingredients-section-column').removeClass('overlay-active');
  });

}
function initStickyAddToCart() {
  const $stickyAddToCart = $('.payment-sticky');
  const $productSection = $('.payment-wrapper');

  if ($stickyAddToCart.length && $productSection.length) {
      const productBottom = $productSection.offset().top + $productSection.outerHeight();

      $(window).on('scroll.stickyAddToCart', function() {
          const scrollTop = $(window).scrollTop();

          if (scrollTop > productBottom) {
              if (!$stickyAddToCart.hasClass('active')) {
                  $stickyAddToCart.addClass('active');
              }
          } else {
              if ($stickyAddToCart.hasClass('active')) {
                  $stickyAddToCart.removeClass('active');
              }
          }
      });

      $('.add-to-cart-btn').on('click.stickyAddToCart', function() {
          $stickyAddToCart.removeClass('active');
      });
  }
}

function reinitStickyAddToCart() {
  if ($('.payment-sticky').length) {
      $(window).off('scroll.stickyAddToCart');
      $('.add-to-cart-btn').off('click.stickyAddToCart');
      initStickyAddToCart();
  }
}

$(document).ready(function() {
  if ($('.payment-sticky').length) {
      initStickyAddToCart();
  }
});
function initializeUniqueAccordion(uniqueDomNode) {
  const uniqueButtonEl = uniqueDomNode.querySelector('.accordion-button[aria-expanded]');
  const uniqueContentEl = document.getElementById(uniqueButtonEl.getAttribute('aria-controls'));
  let isUniqueOpen = uniqueButtonEl.getAttribute('aria-expanded') === 'true';

  function toggleUnique(open) {
    if (open === isUniqueOpen) {
      return;
    }

    isUniqueOpen = open;
    uniqueButtonEl.setAttribute('aria-expanded', `${open}`);
    uniqueButtonEl.setAttribute('aria-selected', `${open}`);
    const uniqueAccordionBox = uniqueDomNode;

      if (open) {
        $(uniqueContentEl).slideDown({
          duration: 300,
          complete: function() {
            uniqueContentEl.classList.remove('is-hidden');
            uniqueContentEl.removeAttribute('hidden');
            uniqueContentEl.setAttribute('tabindex', '0');
            console.log("uniqueContentEl",uniqueContentEl)
          }
        });
        uniqueButtonEl.closest('.tab_drawer_heading').classList.add('d_active');
        uniqueAccordionBox.classList.add('active');
      } else {
        $(uniqueContentEl).slideUp({
          duration: 300,
          complete: function() {
            uniqueContentEl.classList.add('is-hidden');
            uniqueContentEl.setAttribute('hidden', '');
            uniqueContentEl.setAttribute('tabindex', '-1'); 
          }
        });
        uniqueButtonEl.closest('.tab_drawer_heading').classList.remove('d_active');
        uniqueAccordionBox.classList.remove('active');
      }
    }


  function onUniqueButtonClick() {
    toggleUnique(!isUniqueOpen);
  }

  function onUniqueButtonKeydown(event) {
    const uniqueIndex = Array.from(uniqueButtonEl.parentElement.children).indexOf(uniqueButtonEl);
    const uniqueHeaders = Array.from(uniqueButtonEl.parentElement.children);

    switch (event.key) {
      case 'ArrowDown':
        focusNextUniqueTab(uniqueHeaders, uniqueIndex);
        event.preventDefault();
        break;
      case 'ArrowUp':
        focusPreviousUniqueTab(uniqueHeaders, uniqueIndex);
        event.preventDefault();
        break;
      case 'Home':
        focusUniqueTab(uniqueHeaders, 0);
        event.preventDefault();
        break;
      case 'End':
        focusUniqueTab(uniqueHeaders, uniqueHeaders.length - 1);
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  function focusNextUniqueTab(uniqueHeaders, currentIndex) {
    const nextIndex = (currentIndex + 1) % uniqueHeaders.length;
    focusUniqueTab(uniqueHeaders, nextIndex);
  }

  function focusPreviousUniqueTab(uniqueHeaders, currentIndex) {
    const prevIndex = (currentIndex - 1 + uniqueHeaders.length) % uniqueHeaders.length;
    focusUniqueTab(uniqueHeaders, prevIndex);
  }

  function focusUniqueTab(uniqueHeaders, index) {
    uniqueHeaders[index].querySelector('.accordion-button').focus();
  }

  uniqueButtonEl.addEventListener('click', onUniqueButtonClick);
  uniqueButtonEl.addEventListener('keydown', onUniqueButtonKeydown);

  return {
    open: () => toggleUnique(true),
    close: () => toggleUnique(false),
  };
}
function reinitializeAccordions() {
const uniqueAccordions = document.querySelectorAll('.accordion');
uniqueAccordions.forEach((uniqueAccordionEl) => initializeUniqueAccordion(uniqueAccordionEl));
};

document.addEventListener('DOMContentLoaded', () => {
reinitializeAccordions();
});

function initializeCustomTabs(tablistNode) {
const customTabs = Array.from(tablistNode.querySelectorAll('.tab-link-desk'));
const customTabPanels = customTabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));

const firstCustomTab = customTabs[0];
const lastCustomTab = customTabs[customTabs.length - 1];

customTabs.forEach((tab, index) => {
  tab.tabIndex = -1;
  tab.setAttribute('aria-selected', 'false');
  tab.addEventListener('keydown', (event) => handleTabKeydown(event, customTabs, customTabPanels, firstCustomTab, lastCustomTab));
  tab.addEventListener('click', (event) => handleTabClick(event, customTabs, customTabPanels));
});

updateSelectedTab(firstCustomTab, customTabs, customTabPanels, false);

function updateSelectedTab(selectedTab, tabs, tabPanels, focus = true) {
  tabs.forEach((tab, index) => {
    if (selectedTab === tab) {
      tab.setAttribute('aria-selected', 'true');
      tab.removeAttribute('tabindex');
      tabPanels[index].classList.remove('is-hidden');
      if (focus) {
        tab.focus();
      }
    } else {
      tab.setAttribute('aria-selected', 'false');
      tab.tabIndex = -1;
      tabPanels[index].classList.add('is-hidden');
    }
  });
}

function setPreviousTab(currentTab, tabs, tabPanels, firstTab, lastTab) {
  if (currentTab === firstTab) {
    updateSelectedTab(lastTab, tabs, tabPanels);
  } else {
    const index = tabs.indexOf(currentTab);
    updateSelectedTab(tabs[index - 1], tabs, tabPanels);
  }
}

function setNextTab(currentTab, tabs, tabPanels, firstTab, lastTab) {
  if (currentTab === lastTab) {
    updateSelectedTab(firstTab, tabs, tabPanels);
  } else {
    const index = tabs.indexOf(currentTab);
    updateSelectedTab(tabs[index + 1], tabs, tabPanels);
  }
}

function handleTabKeydown(event, tabs, tabPanels, firstTab, lastTab) {
  let shouldPreventDefault = false;

  switch (event.key) {
    case 'ArrowLeft':
      setPreviousTab(event.currentTarget, tabs, tabPanels, firstTab, lastTab);
      shouldPreventDefault = true;
      break;

    case 'ArrowRight':
      setNextTab(event.currentTarget, tabs, tabPanels, firstTab, lastTab);
      shouldPreventDefault = true;
      break;

    case 'Home':
      updateSelectedTab(firstTab, tabs, tabPanels);
      shouldPreventDefault = true;
      break;

    case 'End':
      updateSelectedTab(lastTab, tabs, tabPanels);
      shouldPreventDefault = true;
      break;

    default:
      break;
  }

  if (shouldPreventDefault) {
    event.stopPropagation();
    event.preventDefault();
  }
}

function handleTabClick(event, tabs, tabPanels) {
  updateSelectedTab(event.currentTarget, tabs, tabPanels);
}
}

// Initialize custom tabs

window.addEventListener('load', function () {
const customTabLists = document.querySelectorAll('[role=tablist].automatic');
customTabLists.forEach(tablistNode => {
  initializeCustomTabs(tablistNode);
});
});
function reinitializeCustomTabs() {
const customTabLists = document.querySelectorAll('[role=tablist].automatic');
customTabLists.forEach(tablistNode => {
  initializeCustomTabs(tablistNode);
});
}
reinitializeCustomTabs();
initializeIngredientsSlider('.ingredients-section-inner', '.in-prev-btn', '.in-next-btn');
initializeSlickSlider('.dilutions-section-left-wrapper', '.prev-btn', '.next-btn');
initializeSwatchEvents();
initializeVariantEvents();
initializeCloseButtonEvent();
function handleArrowClick() {
$('.product__main-photos-wrapper').on('click', '.slick-arrow', function(event) {
  
  if ($(this).hasClass('slick-disabled')) {
      resetSlickTrackPosition();
      
      event.preventDefault();
      event.stopImmediatePropagation();
  }
});
}

function resetSlickTrackPosition() {
$('.product__thumbs .slick-track').css({
  'transform': 'translate3d(0px, 0px, 0px)',
  'transition': 'none'
});
}

handleArrowClick();



function initializeSlickDotsAccessibility() {
  document.querySelectorAll('.slick-dots li').forEach((li, index) => {
    const button = li.querySelector('button');
    const isActive = li.classList.contains('slick-active'); 
    
    // Set attributes for <button> element
    button.setAttribute('role', 'tab');
    button.setAttribute('id', `slick-slide${10 + index}`);
    button.setAttribute('aria-controls', `navigation${10 + index}`);
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    button.setAttribute('tabindex', isActive ? '0' : '-1');
  });

// Optional: Add event listeners for click handling if needed
document.querySelectorAll('.slick-dots button').forEach((button) => {
  button.addEventListener('click', (event) => {
    const currentTab = event.currentTarget;
    const tabs = currentTab.closest('.slick-dots').querySelectorAll('button');

    tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
      tab.closest('li').classList.remove('slick-active');
    });

    currentTab.setAttribute('aria-selected', 'true');
    currentTab.setAttribute('tabindex', '0');
    currentTab.closest('li').classList.add('slick-active');
    currentTab.focus();
  });
});
}
function initializeSlickSliderfq(selector, prevBtnSelector, nextBtnSelector) {
  // Initialize the slick slider
  $(selector).slick({
    dots: false,
    infinite: false,
    accessibility:false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // Handle custom navigation buttons
  function handleNavigationButtons() {
    $(prevBtnSelector).click(function () {
      $(selector).slick("slickPrev");
    });

    $(nextBtnSelector).click(function () {
      $(selector).slick("slickNext");
    });

    // Initially disable the previous button
    $(prevBtnSelector).addClass("slick-disabled");

    // Update button states after each slide change
    $(selector).on("afterChange", function () {
      toggleButtonState(selector, prevBtnSelector, nextBtnSelector);
    });
  }

  // Function to toggle button state
  function toggleButtonState(slider, prevButton, nextButton) {
    if ($(slider).find(".slick-prev").hasClass("slick-disabled")) {
      $(prevButton).addClass("slick-disabled");
    } else {
      $(prevButton).removeClass("slick-disabled");
    }

    if ($(slider).find(".slick-next").hasClass("slick-disabled")) {
      $(nextButton).addClass("slick-disabled");
    } else {
      $(nextButton).removeClass("slick-disabled");
    }
  }

  handleNavigationButtons(); // Initialize the button handlers
}
initializeSlickDotsAccessibility();
initializeSlickSliderfq('.frequently-section', '.prev-btn-fq', '.next-btn-fq');
document.addEventListener('DOMContentLoaded', function () {
  let currentProductHandle = null;
  const initialSectionId = document.querySelector('.product-section')?.getAttribute('data-section-id');
  if (!initialSectionId) return;

  const productContainer = document.querySelector('#shopify-section-product-template-new');
  if (!productContainer) return;

  // Attach click listeners to swatch/grid product buttons
  function attachEventListeners() {
    const productButtons = document.querySelectorAll('.grid-product__swatch');
    productButtons.forEach(button => {
      // remove any previous handler to avoid double-binding
      button.replaceWith(button.cloneNode(true));
    });

    // Re-select after cloning to get fresh elements
    const freshButtons = document.querySelectorAll('.grid-product__swatch');
    freshButtons.forEach(button => {
      button.addEventListener('click', async function (event) {
        event.preventDefault();
        const productHandle = this.getAttribute('data-product-handle');
        if (!productHandle) return;
        if (productHandle !== currentProductHandle) {
          await updateProduct(productHandle);
        }
      });
    });
  }

  // Update product content by fetching the product page HTML and replacing relevant sections
  async function updateProduct(productHandle) {
    const url = `/products/${productHandle}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);

      const html = await response.text();
      const newDocument = new DOMParser().parseFromString(html, 'text/html');

      const newProductSection = newDocument.querySelector('.product-section');
      const newPdpSections = newDocument.querySelectorAll('.pdp-section');

      if (!newProductSection) {
        console.warn('Fetched product page does not contain .product-section for', productHandle);
        return;
      }

      // Clear container and append cloned nodes from fetched HTML
      productContainer.innerHTML = '';
      productContainer.appendChild(newProductSection.cloneNode(true));

      newPdpSections.forEach(section => {
        productContainer.appendChild(section.cloneNode(true));
      });

      // If there is a JSON script with variant metafields, parse it safely
      const metafieldsScript = newDocument.querySelector('#VariantMetafields');
      if (metafieldsScript && metafieldsScript.textContent) {
        try {
          window.variantMetafields = JSON.parse(metafieldsScript.textContent);
        } catch (e) {
          console.error('Error parsing VariantMetafields JSON:', e);
        }
      }

      // Update URL and document title
      history.replaceState({}, "", `/collections/all/products/${productHandle}`);
      currentProductHandle = productHandle;

      const productTitleElement = newDocument.querySelector('#product__title');
      if (productTitleElement) {
        const productTitle = productTitleElement.textContent.trim();
        document.title = `${productTitle} – Dr. Bronner's`;
      }

      // Optional: extract id and price (safe parsing)
      const pdpPriceEl = newDocument.querySelector('.product-price .price');
      let pdpPrice;
      if (pdpPriceEl) {
        const priceText = pdpPriceEl.textContent || '';
        const parsed = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        pdpPrice = Number.isFinite(parsed) ? parsed : undefined;
      }
      const pdpIdEl = newDocument.querySelector('[data-product-id]') || newDocument.querySelector('[data-id]');
      const pdpId = pdpIdEl ? (pdpIdEl.getAttribute('data-product-id') || pdpIdEl.getAttribute('data-id')) : productHandle;

      // Re-attach event listeners for newly injected elements
      attachEventListeners();

      // Re-initialize theme-specific / UI functions if available
      try {
        if (typeof reinitializeCustomTabs === 'function') reinitializeCustomTabs();
        if (typeof initializeSwatchEvents === 'function') initializeSwatchEvents();
        if (typeof reinitializeAccordions === 'function') reinitializeAccordions();
        if (typeof initializeVariantEvents === 'function') initializeVariantEvents();
        if (typeof handleArrowClick === 'function') handleArrowClick();
        if (typeof fetchCartTotal === 'function') fetchCartTotal();
        if (typeof initializeSlickDotsAccessibility === 'function') initializeSlickDotsAccessibility();
        if (typeof initStickyAddToCart === 'function') initStickyAddToCart();
        if (typeof initializeSlickSlider === 'function') initializeSlickSlider('.dilutions-section-left-wrapper', '.prev-btn', '.next-btn');
        if (typeof initializeIngredientsSlider === 'function') initializeIngredientsSlider('.ingredients-section-inner', '.in-prev-btn', '.in-next-btn');
        if (typeof initializeSlickSliderfq === 'function') initializeSlickSliderfq('.frequently-section', '.prev-btn-fq', '.next-btn-fq');
        if (typeof initializeViewAllScroll === 'function') initializeViewAllScroll();
        if (window.innerWidth >= 768 && typeof initializeSlickSlidereview === 'function') {
          initializeSlickSlidereview('.block-best-review-section-inner');
        }

        // Re-register Shopify theme sections if available (guarded)
        if (window.sections && sections.register) {
          if (window.theme && theme.VideoSection) sections.register('video-section', theme.VideoSection);
          if (window.theme && theme.Product) {
            sections.register('product', theme.Product);
            sections.register('product-template', theme.Product);
          }
        }
      } catch (e) {
        console.warn('Error while running post-insert initializers:', e);
      }

    } catch (error) {
      console.error('Error fetching product:', error);
    }
  }
  // initial listener attachment
  attachEventListeners();
});
function initSliderSync() {
  const $mainSliders = $('.product__main-photos-wrapper');
  const $thumbSliders = $('.product__thumbs');
  $mainSliders.slick('refresh');
  $thumbSliders.slick('refresh');
  // Sync the main slider with the thumbnail clicks
  $thumbSliders.on('click', '.slick-slide', function(event) {
      const indeximage = $(this).data('slick-index');

    setTimeout(() => {
      $mainSliders.slick('slickGoTo', indeximage);
    }, 0);


      console.log("index",indeximage)
  });

  // Optional: Re-sync after filtering
  $mainSliders.slick('refresh');
  $thumbSliders.slick('refresh');
}


class ProductRecommendations extends HTMLElement {
  observer = undefined;

constructor() {
  super();
}

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

initializeRecommendations(productId) {
  this.observer?.unobserve(this);
  this.observer = new IntersectionObserver(
    (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations(productId);
    },
    { rootMargin: '0px 0px 400px 0px' }
  );
  this.observer.observe(this);
}

loadRecommendations(productId) {
  fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');

      if (recommendations?.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
      }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        initializeSlickSliderfq('.frequently-section.product-row', '.prev-btn-fq', '.next-btn-fq');
        const checkAndInitializeSlick = () => {
          if ($('.more-product-section .product-row .grid-product__content').length > 0) {
            $('.more-product-section .product-row').slick({
              accessibility:false,
              arrows: true,
              infinite: false,
              slidesToShow: 2,
              rows: 1,
              mobileFirst: true,
              slidesToScroll: 2,
              swipe: true,           
              touchMove: true,        
              swipeToSlide: true,   
              adaptiveHeight: false,
              responsive: [
                {
                  breakpoint: 0,
                  settings: {
                    rows: 2,
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    rows: 2,
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 1280,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1
                  }
                }
              ]
            });
          } else {
            setTimeout(checkAndInitializeSlick, 500);
          }
        };

        checkAndInitializeSlick();

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error('Error loading recommendations:', e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function initializeViewAllScroll() {
  const viewAllButton = document.querySelector('.view-all');
  if (viewAllButton) {
      viewAllButton.addEventListener('click', function () {
          const targetElement = document.querySelector('#bv_review_maincontainer');
          const offset = 120;

          if (targetElement) {
              const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - offset;

              window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
              });
          }
      });
  }
}
initializeViewAllScroll();
$('.slick-slider').on('init reInit afterChange', function(event, slick, currentSlide){
  $('.slick-slider .slick-slide[data-slick-index="' + currentSlide + '"]').each(function(){
      $(this).removeAttr('aria-describedby');
  });
});